<template>

  <div class="mOperation-wrap">
    <!----------- operation ---------->
      <ul class="clearfix">
        <li class="pull-left" :class="{'checked' : !selectAllRows && checkedRows.length >0 }">
          <template v-if="gridConfig.canCheckedAll">
            <span class="main-operation-data" v-show="!selectAllRows && checkedRows.length > 0">
              已选择 <span>{{ checkedRows.length }}</span>/{{ totalCount }}条数据，<a @click="handleSelectAllRow" href="javascript:" class="btn-link">选择全部数据</a>
            </span>
            <span class="main-operation-data" v-show="selectAllRows && checkedRows.length > 0">
              已选择全部 <span>{{ totalCount }}</span> 条筛选结果
            </span>
          </template>
          <template v-else>
            <span class="main-operation-data" v-show="!selectAllRows && checkedRows.length > 0">
              已选择 <span>{{ checkedRows.length }}</span>/{{ totalCount }} 条数据
            </span>
          </template>
          <!--非必选记录菜单-->
          <span v-show="checkedRows.length === 0">
            <a href="javascript:" ondragstart="return false"
               class="btn btn-hollow-primary btn-icon"
               v-show="gridConfig.canAdd"
               @click="handleAddButton()"
            ><i class="mng icon-icon-test-copy"></i><span>添加</span></a>
            <a href="javascript:" ondragstart="return false"
               class="btn btn-hollow-dark btn-icon"
               v-show="gridConfig.canBatchAdd"
               @click="handleImport()"
            ><i class="mng icon-batchimport-stroke1"></i><span>导入</span></a>
            <a href="javascript:" ondragstart="return false"
               class="btn btn-hollow-dark"
               v-for="menu in gridConfig.gridMenuList"
               v-if="menu.showType === 'top' && !menu.mustSelectRow && menu.type !== 'magicalMenu'"
               @click="handleMenuClick(menu)"
            >{{ menu.text }}</a>
            <slot name="topNoSelectMenus"></slot>
          </span>
          <!--必选记录菜单-->
          <a
            href="javascript:" ondragstart="return false"
            :class="'btn btn-icon ' + (checkedRows.length > 0 ? 'btn-hollow-dark' : 'btn-hind')"
            v-show="gridConfig.canDelete"
            @click="checkedRows.length > 0 && handleDelete()"
          ><i class="mng icon-delete-stroke"></i><span>删除</span></a>
          <a href="javascript:" ondragstart="return false"
             :class="'btn ' + (checkedRows.length > 0 ? 'btn-hollow-dark' : 'btn-hind')"
             v-for="menu in gridConfig.gridMenuList"
             v-if="menu.showType === 'top' && menu.mustSelectRow && menu.type !== 'magicalMenu'"
             @click="checkedRows.length > 0 && handleMenuClick(menu)"
          >{{ menu.text }}</a>
          <!--自定义必选菜单：未勾选置灰，勾选后可用-->
          <slot name="topSelectMenus"></slot>
        </li>
        <li class="pull-right">
          <a href="javascript:" v-show="checkedRows.length > 0"
             ondragstart="return false"
             class="btn btn-hollow-dark btn-shut"
             @click="handleClearCheckRow"
          >取消
          </a>
          <div v-show="checkedRows.length === 0">
            <!--保存视图-->
            <div class="pull-right-item">
              <a @click="handleSaveUserGridConfig"
                 href="javascript:" ondragstart="return false" class="btn btn-anti-primary">保存视图</a>
            </div>

            <!--恢复系统默认视图-->
            <div class="pull-right-item">
              <el-tooltip class="item" effect="dark" content="恢复系统默认视图" placement="top">
                <a @click="handleResetUserGridConfig" href="javascript:" class="btn btn-hollow-dark btn-icon-only"><i class="mng icon-refresh-fold"></i></a>
              </el-tooltip>
            </div>

            <div class="pull-right-item">
              <el-dropdown trigger="click" :show-timeout="10" >
                <el-tooltip class="item" effect="dark" content="选择字段" placement="top">
                  <a href="javascript:" class="btn btn-hollow-dark btn-icon-only"><i class="mng icon-field-stroke1"></i></a>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown" >
                  <div class="drop-operation select-column-drop">
                    <div class="drop-top">
                      <div class="drop-field">
                        <span class="pull-left drop-txt">选择显示字段</span>
                        <div class="pull-right drop-checkbox" style="padding-left: 0">
                          <label class="form-label" :class="{'active': showAllColumn}">
                            <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                            <input type="checkbox" checked="checked" v-model="showAllColumn" @click="handleShowAllColumnCheckbox">
                            <div class="form-label-con">全选</div>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="drop-mid">
                      <el-scrollbar class="whaty-scroll">
                        <ul class="drop-list-wrap" id="fieldlist">
                          <li v-for="item in gridConfig.listColumnConfig"
                              v-if="item.list"
                              @click="toggleColumnShow(item)"
                              class="drop-list">
                            <a href="javascript:" class="drop-link has-tick" :class="{'drop-select': (item.show === undefined || item.show)}" >
                              <span class="drop-txt">{{ item.name }}</span>
                              <i class="mng icon-tick-stroke drop-ico-suf drop-ico-tick"></i>
                            </a>
                          </li>
                        </ul>
                      </el-scrollbar>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="pull-right-item">
              <el-dropdown trigger="click" :show-timeout="10" >
                <el-tooltip class="item" effect="dark" content="冻结列" placement="top">
                  <a href="javascript:" class="btn btn-hollow-dark btn-icon-only"><i class="mng icon-freeze-stroke1"></i></a>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown" >
                  <div class="drop-operation select-column-drop">
                    <div class="drop-top">
                      <div class="drop-field">
                        <span class="pull-left drop-txt">选择冻结字段</span>
                      </div>
                    </div>
                    <div class="drop-mid">
                      <el-scrollbar class="whaty-scroll">
                        <ul class="drop-list-wrap" id="fixFieldlist">
                          <li v-for="item in gridConfig.listColumnConfig"
                              v-if="item.list"
                              @click="toggleColumnFix(item)"
                              class="drop-list">
                            <a href="javascript:" class="drop-link has-tick" :class="{'drop-select': (item.fix === 'left')}">
                              <span class="drop-txt">{{ item.name }}</span>
                              <i class="mng icon-tick-stroke drop-ico-suf drop-ico-tick"></i>
                            </a>
                          </li>
                        </ul>
                      </el-scrollbar>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </li>
      </ul>
    </div>
</template>
<script>
  import WhatyDialog from '../dialog/dialog.vue'

  export default {
    name: 'grid-top-operation',
    components: {
      WhatyDialog
    },
    props: {
      gridConfig: {},
      checkedRows: {
        type: Array,
        default() {
          return []
        }
      },
      showSearchForm: {
        type: Boolean,
        required: true
      },
      pageSize: {
        type: Number,
        default: 0
      },
      curPage: {
        type: Number,
        default: 0
      },
      totalCount: {
        type: Number,
        default: 0
      },
      selectAllRows: {
        type: Boolean
      },
      updateColumnUrl: {
        type: String,
        required: true
      },
      menus: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        addButtonStatus: false, // 添加按钮开关
        showSelectColumnPanel: false, // 显示选择列面板
        showFreezeColumnPanel: false, // 显示选择冻结列面板
        freezeColumn: 0 // 冻结的列
      }
    },
    computed: {
      showAllColumn: { // 显示全部列
        get: function () {
          if (this.gridConfig.listColumnConfig) {
            for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
              if (this.gridConfig.listColumnConfig[i].list && this.gridConfig.listColumnConfig[i].show === false) {
                return false
              }
            }
          }
          return true
        },
        set: function (newValue) {}
      },
      gridConfigUrl: function () {
        return this.$route.meta.url
      }
    },
    created: function () {
    },
    methods: {
      handleClearCheckRow() {
        this.$emit('clear-check-row')
      },
      handleSelectAllRow() {
        this.$emit('select-all-row')
      },
      handleAddButton() { // 点击添加按钮
        this.$emit('add-button-click')
      },
      handleImport() { // 点击导入按钮
        this.$emit('import')
      },
      handleDelete() { // 删除
        this.$emit('delete-button-click')
      },
      toggleColumnShow(column) { // 切换列显示隐藏
        this.$emit('toggle-column-show', column)
      },
      toggleColumnFix(column) { // 切换列冻结状态
        this.$emit('toggle-column-fix', column)
      },
      handleShowAllColumnCheckbox(e) { // 全选 / 取消全选
        if (e.target.checked) {
          this.$emit('show-all-column')
        } else {
          this.$emit('hide-all-column')
        }
      },
      handleMenuClick(menu) {
        this.$emit('menu-click', menu)
      },
      handleGridMenuClick(gridMenu) {
        if (gridMenu.menuClick && typeof gridMenu.menuClick === 'function') {
          gridMenu.menuClick.call(this, gridMenu)
        }
      },
      // 保存用户的grid视图状态
      handleSaveUserGridConfig() {
        this.$msgBox.showMsgBox({
          title: '提示',
          content: '是否确定保存当前视图',
          type: 'warning'
        }).then(() => {
          this.$emit('save-user-grid-config')
        }).catch(() => {
        })
      },
      // 重置用户的grid视图状态
      handleResetUserGridConfig() {
        this.$emit('reset-user-grid-config')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/grid-top-operation.vue